import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import PropTypes from 'prop-types'

export default function MembersLoading({ label, detail, compact = false, className = '' }) {
  const { t } = useOptionalPrivanaI18n()
  const loadingLabel = label === undefined ? t("element.common.loading") : label
  return <div className={`mp-play-loading${compact ? ' mp-play-loading--compact' : ''}${className ? ` ${className}` : ''}`} role="status" aria-live="polite" aria-label={loadingLabel}>
    <span className="mp-play-loading__mark" aria-hidden="true"><i /><i /><i /></span>
    <span className="mp-play-loading__copy"><strong>{loadingLabel}</strong>{detail ? <small>{detail}</small> : null}</span>
  </div>
}

MembersLoading.propTypes = {
  label: PropTypes.string,
  detail: PropTypes.string,
  compact: PropTypes.bool,
  className: PropTypes.string,
}
